export { default } from './RegistrationEdit'



// WEBPACK FOOTER //
// ./src/App/pages/EventRegistration/RegistrationEdit/index.js